var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';
import WixComponent from '../../BaseComponents/WixComponent';
import BaseTextLink from '../../BaseComponents/TextLink';

var TextLink = function (_WixComponent) {
  _inherits(TextLink, _WixComponent);

  function TextLink() {
    _classCallCheck(this, TextLink);

    return _possibleConstructorReturn(this, (TextLink.__proto__ || Object.getPrototypeOf(TextLink)).apply(this, arguments));
  }

  _createClass(TextLink, [{
    key: 'render',
    value: function render() {

      return React.createElement(BaseTextLink, this.props);
    }
  }]);

  return TextLink;
}(WixComponent);

TextLink.propTypes = Object.assign({}, BaseTextLink.propTypes, {
  link: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  download: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top', 'framename']),
  ariaLabel: PropTypes.string
});
TextLink.defaultProps = Object.assign({}, BaseTextLink.defaultProps, {
  disabled: false,
  download: false,
  rel: null,
  target: null
});
export default TextLink;
//# sourceMappingURL=TextLink.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Backoffice/TextLink/TextLink.js